import { useBreakpointValue } from "../../hooks/use-breakpoint-value";

export function useShowUtilization(): boolean {
  return useBreakpointValue(true, { md: false });
}
